<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Cotizador de Trabajos">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="2"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <app-rubro-trabajo
              label="Rubro"
              :nombre="rubroTrabajoNombre"
              :valido="rubroTrabajoValido"
              :lista="rubrosList"
              :msjInvalido="rubroTrabajoInvalidoMsj"
              :labelCols= "labelCols"
              @validate="validate"
              @updated="rubroTrabajoActualizado">
            </app-rubro-trabajo>  

            <b-form-group
              label=""
              label-for="rubroTrabajoDescripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="rubroTrabajoDescripcion"
                :value= "rubroTrabajoDescripcion" 
                rows="2"
                max-rows="2"
                readonly>
              </b-form-textarea>
            </b-form-group>

            <app-categoria-servicio
              v-if="discriminarCategoriaServicio"
              label="Categoría"
              :nombre="categoriaServicioNombre"
              :valido="categoriaServicioValida"
              :lista="categoriasServiciosList"
              :msjInvalido="categoriaServicioInvalidaMsj"
              :labelCols= "labelCols"
              description="Categoría de Servicio"
              @validate="validate"
              @updated="categoriaServicioActualizada">
            </app-categoria-servicio>  

            <!-- <app-moneda
              label="Moneda"
              :nombre="monedaNombre"
              :labelCols="labelCols"
              :valido="monedaValida"
              :lista="monedasList"
              :msjInvalido="monedaInvalidaMsj"
              @validate="validate"
              @updated="monedaActualizada">
            </app-moneda>   -->

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Cantidad"
                  label-for="cantidad"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="cantidad"
                    v-model.trim= "$v.cantidad.$model" 
                    :state="cantidadValida"
                    type="text"
                    @blur.native="validate"
                    @input.native="calcularCostos">
                  </b-form-input>
                  <b-form-invalid-feedback id="cantidadFeedback">
                    {{ cantidadInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Costo Unitario"
                  label-for="costoEstimado"
                  description="Costo Unitario IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoUnitarioSelected" 
                        :value="Boolean(true)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <app-formatted-costo-unitario
                      id="costoEstimado"
                      :importe="costoEstimado"
                      :moneda="monedaNombre"
                      cssClass="form-control"
                      :readonly="costoDisabled"
                      @actualizarImporte="actualizarCostoUnitario">
                    </app-formatted-costo-unitario>
                    <!-- <b-form-input 
                      id="costoEstimado" 
                      v-model.trim= "$v.costoEstimado.$model" 
                      type="text"
                      :readonly="costoDisabled"
                      :state="costoEstimadoValido"
                      @blur.native="validate"
                      @input.native="calcularCostoTotal">
                    </b-form-input> -->
                  </b-input-group>
                  <b-form-invalid-feedback id="costoEstimadoFeedback">
                    {{ costoEstimadoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="Costo Total"
                  label-for="costoEstimadoTotal"
                  description="Costo Total IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoTotalSelected" 
                        :value="Boolean(false)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <app-formatted-costo-total
                      id="costoEstimadoTotal"
                      :importe="costoEstimadoTotal"
                      :moneda="monedaNombre"
                      cssClass="form-control"
                      :readonly="costoTotalDisabled"
                      @actualizarImporte="actualizarCostoTotal">
                    </app-formatted-costo-total>
                    <!-- <b-form-input 
                      id="costoEstimadoTotal" 
                      v-model.trim= "$v.costoEstimadoTotal.$model" 
                      type="text"
                      :readonly="costoTotalDisabled"
                      :state="costoEstimadoTotalValido"
                      @blur.native="validate"
                      @input.native="calcularCostoUnitario">
                    </b-form-input> -->
                  </b-input-group>
                  <b-form-invalid-feedback id="costoEstimadoTotalFeedback">
                    {{ costoEstimadoTotalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group
              label="Costo Interno"
              label-for="costoInterno"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="costoInterno"
                :value="costoInterno | moneda" 
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="% Rentabilidad"
              label-for="pjeRentabilidad"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeRentabilidad" 
                v-model.trim="$v.pjeRentabilidad.$model" 
                type="text"
                :state="pjeRentabilidadValido"
                @blur.native="validate"
                @input.native="actualizarPjeRentabilidad">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Cotizacion Interna"
              label-for="cotizacionInterna"
              :label-cols="labelCols"
              v-if="pjeRecargoServicioPropio != 0"
              horizontal>
              <app-formatted-cotizacion-interna
                id="cotizacionInterna"
                :importe="cotizacionInterna"
                :moneda="monedaNombre"
                cssClass="form-control"
                @actualizarImporte="actualizarCotizacionInterna">
              </app-formatted-cotizacion-interna>
            </b-form-group>

            <b-form-group
              label="Cotizacion"
              label-for="cotizacion"
              :label-cols="labelCols"
              horizontal>
              <app-formatted-cotizacion
                id="cotizacion"
                :importe="cotizacion"
                :moneda="monedaNombre"
                cssClass="form-control"
                :readonly="pjeRecargoServicioPropio != 0"
                @actualizarImporte="actualizarCotizacion">
              </app-formatted-cotizacion>
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cerrar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import RubroTrabajo from '../shared/abmSelect.vue';
import CategoriaServicio from '../shared/abmSelect.vue';
import Moneda from '../shared/abmSelect.vue';
import FormattedCostoUnitario from '../shared/formattedCurrency.vue';
import FormattedCostoTotal from '../shared/formattedCurrency.vue';
import FormattedCotizacionInterna from '../shared/formattedCurrency.vue';
import FormattedCotizacion from '../shared/formattedCurrency.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { required, numeric, decimal, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cotizador/getField',
  mutationType: 'cotizador/updateField',
});

export default {
  name: 'OrdenesTrabajosCotizador',
  components: {
    appSearchCliente: SearchCliente,
    appRubroTrabajo: RubroTrabajo,
    appCategoriaServicio: CategoriaServicio,
    appMoneda: Moneda,
    appFormattedCostoUnitario: FormattedCostoUnitario,
    appFormattedCostoTotal: FormattedCostoTotal,
    appFormattedCotizacionInterna: FormattedCotizacionInterna,
    appFormattedCotizacion: FormattedCotizacion,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      rubroTrabajoValido: null,
      rubroTrabajoInvalidoMsj: '',
      categoriaServicioValida: null,
      categoriaServicioInvalidaMsj: '',
      tituloValido: null,
      tituloInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      cantidadValida: null,
      cantidadInvalidaMsj: '',
      monedaValida: null,
      monedaInvalidaMsj: '',
      costoEstimadoValido: null,
      costoEstimadoInvalidoMsj: '',
      costoEstimadoTotalValido: null,
      costoEstimadoTotalInvalidoMsj: '',
      pjeRentabilidadValido: null,
      pjeRentabilidadInvalidoMsj: '',

      categoriasServicios: [],
      categoriasServiciosList: [],
      monedas: [],
      monedasList: [],
      rubros: [],
      rubrosList: [],

      labelCols: 2,
      inicializandoRubros: false,
      inicializandoCategorias: false,
      inicializandoMonedas: false,
    }
  },
  computed: {
    ...mapFields([
      'cliente',
      'clienteNombre',
      'rubroTrabajo',
      'rubroTrabajoNombre',
      'rubroTrabajoDescripcion',
      'categoriaServicio',
      'categoriaServicioNombre',
      'cantidad',
      'monedaId',
      'moneda',
      'monedaNombre',
      'costoEstimado',
      'costoEstimadoTotal',
      'costoUnitario',
      'feeAgencia',
      'costoInterno',
      'pjeRentabilidad',
      'cotizacionInterna',
      'cotizacion',
      // 'rubros',
      // 'rubrosList',
      'discriminarCategoriaServicio',
      'pjeRecargoServicioPropio'
    ]),
    costoDisabled() {
      return !this.costoUnitario;
    },
    costoTotalDisabled() {
      return Boolean(this.costoUnitario);
    },
  },  
  created() {
    this.$store.dispatch('cotizador/inicializar')
      .then(() => this.getDatosAdicionales());
  }, 
  methods: {
    getDatosAdicionales() {
      this.inicializandoCategorias = true;
      this.$store.dispatch('categoriasServicios/getList')
        .then(() => {
          this.categoriasServicios = this.$store.getters['categoriasServicios/list'];
          this.categoriasServiciosList = this.$store.getters['categoriasServicios/selectList'];
          this.inicializandoCategorias = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de categorías.'));

      this.inicializandoMonedas = true;
      this.$store.dispatch('monedas/getList')
        .then(() => {
          this.monedas = this.$store.getters['monedas/list'];
          this.monedasList = this.$store.getters['monedas/selectList'];
          this.inicializandoMonedas = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de monedas.'));
    },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'titulo' || validarTodos) {
        if (this.$v.titulo.$error) {
          this.tituloValido = false;
          if (!this.$v.titulo.required) {
            this.tituloInvalidoMsj= 'Debe ingresar el título de la orden.';
          } else if (!this.$v.titulo.maxLength) {
            this.tituloInvalidoMsj = 'El título sólo puede contener hasta 30 caracteres';
          }
        } else {
          this.tituloValido = null;
          this.tituloInvalidoMsj = '';
        }
      }

      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción sólo puede contener hasta 5000 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }

      if (campo == 'cantidad' || validarTodos) {
        if (this.$v.cantidad.$error) {
          this.cantidadValida = false;
          if (!this.$v.cantidad.numeric) {
            this.cantidadInvalidaMsj = 'La cantidad debe ser un valor numérico positivo';
          } else {
            if (!this.$v.cantidad.minValue) {
              this.cantidadInvalidaMsj = 'La cantidad ingresada no es válida';
            }      
          }
        } else {
          this.cantidadValida = null;
          this.cantidadInvalidaMsj = '';
        }
      }

      if (this.costoUnitario) {
        if (campo == 'costoEstimado' || validarTodos) {
          if (this.$v.costoEstimado.$error) {
            this.costoEstimadoValido = false;
            if (!this.$v.costoEstimado.decimal || !this.$v.costoEstimado.minValue) {
              this.costoEstimadoInvalidoMsj = 'El costo ingresado no es válido';
            }
          } else {
            this.costoEstimadoValido = null;
            this.costoEstimadoInvalidoMsj = '';
          }
        }
      } else {
        if (campo == 'costoEstimadoTotal' || validarTodos) {
          if (this.$v.costoEstimadoTotal.$error) {
            this.costoEstimadoTotalValido = false;
            if (!this.$v.costoEstimadoTotal.decimal || !this.$v.costoEstimadoTotal.minValue) {
              this.costoEstimadoTotalInvalidoMsj = 'El costo total ingresado no es válido';
            }
          } else {
            this.costoEstimadoTotalValido = null;
            this.costoEstimadoTotalInvalidoMsj = '';
          }
        }
      }
    },
    seleccionarCliente() {
      this.$refs.searchClienteModal.show();
    },
    clienteSeleccionado(cliente) {
      this.$refs.searchClienteModal.hide();

      this.inicializandoRubros = true;
      this.$store.dispatch('cotizador/setCliente', cliente)
        .then(() => {
          this.inicializandoRubros = false;
          this.rubros = this.$store.getters['cotizador/rubros'];
          this.rubrosList = this.$store.getters['cotizador/rubrosList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de rubros de trabajo.'));

    },
    rubroTrabajoActualizado(rubro) {
      if (!this.inicializandoRubros) {
        if (this.rubros) {
          if (this.rubros.length != 0) {
            let rubroTrabajo;
            this.rubroTrabajoNombre = rubro;
            if (this.rubroTrabajoNombre) {
              rubroTrabajo = this.getSelected(this.rubros, this.rubroTrabajoNombre);
              this.rubroTrabajoValido = null;
              this.rubroTrabajoInvalidoMsj = '';
            }
            this.$store.dispatch('cotizador/setRubroTrabajo', rubroTrabajo);
          }
        }
      }
    },
    categoriaServicioActualizada(categoriaServicioNombre) {
      if (!this.inicializandoCategorias) {
        let categoriaServicio;
        if (categoriaServicioNombre) {
          categoriaServicio = this.getSelected(this.categoriasServicios, categoriaServicioNombre);
        }
        this.$store.dispatch('cotizador/setCategoriaServicio', categoriaServicio);

        this.categoriaServicioValida = null;
        this.categoriaServicioInvalidaMsj = '';
      }
    },
    monedaActualizada(monedaNombre) {
      if (!this.inicializandoMonedas) {
        this.monedaNombre = monedaNombre;

        if (this.monedaNombre) {
          let moneda = this.getSelected(this.monedas, this.monedaNombre);
          this.$store.dispatch('cotizador/setMoneda', moneda)
            .catch(error => this.showErrorMsj(error))

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
    calcularCostos() {
      if ((/true/i).test(this.costoUnitario)) {
        this.$store.dispatch('cotizador/calcularCostoTotal');  
      } else {
        this.$store.dispatch('cotizador/calcularCostoUnitario');
      }     
    },
    actualizarCostoUnitario(params) {
      this.costoEstimado = params.importe;
      
      this.$store.dispatch('cotizador/calcularCostoTotal')
        .catch(error => this.showErrorMsj(error));
    },
    actualizarCostoTotal(params) {
      this.costoEstimadoTotal = params.importe;
      
      this.$store.dispatch('cotizador/calcularCostoUnitario')
        .catch(error => this.showErrorMsj(error));
    },
    actualizarPjeRentabilidad() {
      this.$store.dispatch('cotizador/updatePjeRentabilidad')
        .catch(error => this.showErrorMsj(error));
    },
    actualizarCotizacionInterna(params) {
      let cotizacionInterna = parseFloat(params.importe);

      this.$store.dispatch('cotizador/setCotizacionInterna', cotizacionInterna)
        .catch(error => this.showErrorMsj(error));
    },
    actualizarCotizacion(params) {
      let cotizacion = parseFloat(params.importe);

      this.$store.dispatch('cotizador/setCotizacion', cotizacion)
        .catch(error => this.showErrorMsj(error));
    },
    close() {
      this.$emit('closeCotizador');
    },
  },
  watch: {
  },    
  validations: {
    cantidad: {
      numeric,
      minValue: minValue(0),
    },
    costoEstimado: {
      decimal,
      minValue: minValue(0)
    },
    costoEstimadoTotal: {
      decimal,
      minValue: minValue(0)
    },
    pjeRentabilidad: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
  .custom-radio input[type='text'] {
    margin-left: 50%;
  }
  .text-costos {
    margin-top: 10px;
    margin-left: 120px !important;
  } 
</style>
